// @flow

import formatPlanTiers from '../formatPlanTiers';
import isTierFree from '../isTierFree';

import type { AccountPlan } from '@zapier/billing/src/types';

const findFreeMeteredTier = (tiers = []) => {
  return (
    tiers.find(isTierFree) || {
      numTasks: 0,
      pricePerTask: 0,
    }
  );
};

const getNumFreeMeteredTasks = (plan: AccountPlan) => {
  return findFreeMeteredTier(formatPlanTiers(plan)).numTasks;
};

export default getNumFreeMeteredTasks;
